var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconUpload = function SvgElIconUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el-icon-upload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.333 9.61V14a.667.667 0 0 0 1.334 0V9.61l1.528 1.528a.666.666 0 1 0 .943-.942L8.471 7.529a.665.665 0 0 0-.942 0l-2.667 2.667a.666.666 0 1 0 .943.942L7.333 9.61Zm6.58 3.236a3.99 3.99 0 0 0 1.922-2.383 3.99 3.99 0 0 0-.325-3.044 3.974 3.974 0 0 0-1.973-1.775 4.082 4.082 0 0 0-1.532-.31h-.352a5.98 5.98 0 0 0-2.611-3.168 5.984 5.984 0 0 0-4.547-.64A5.985 5.985 0 0 0 .827 4.29a5.981 5.981 0 0 0-.64 4.547 5.932 5.932 0 0 0 1.317 2.475.666.666 0 1 0 .991-.891 4.59 4.59 0 0 1-1.017-1.918 4.649 4.649 0 0 1 .497-3.537 4.652 4.652 0 0 1 2.853-2.15 4.649 4.649 0 0 1 3.537.498 4.652 4.652 0 0 1 2.149 2.853c.077.29.337.5.646.5h.835a2.74 2.74 0 0 1 1.03.208 2.64 2.64 0 0 1 1.314 1.182c.352.647.41 1.374.216 2.03a2.657 2.657 0 0 1-1.282 1.587.666.666 0 1 0 .639 1.171Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "el-icon-upload_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgElIconUpload;